import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AnonymousPageRoutingModule } from './anonymous-routing.module';

import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { PaymentReceivedPage } from './payment-received/payment-received.page';
import { PaymentFailPage } from './payment-fail/payment-fail.page';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AnonymousPageRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule
  ],
  declarations: [PaymentReceivedPage, PaymentFailPage],
})
export class AnonymousPageModule {}
